export default __webpack_public_path__ + "static/media/profiles.8f5223ba.JPG";